// hooks/useCreateStripeIntegrationOnClick.ts
import { useMutation } from "@tanstack/react-query";
import { createStripeIntegration } from "../api/payments";

/**
 * Hook for creating a Stripe Connect integration.
 * Uses useMutation to handle the POST request with dynamic return_url.
 */
export const useCreateStripeIntegrationOnClick = () => {
  return useMutation({
    mutationFn: (returnUrl?: string) => {
      const content = returnUrl ? { return_url: returnUrl } : {};
      return createStripeIntegration(content);
    },
  });
};
